module.exports = __webpack_public_path__ + "img/stackslash-74-mobile.c72ac26a.jpg";